import {
  IPayeeCreateRequest,
  IPayeeResponse
} from "@wingspanhq/payments/dist/interfaces";
import { WSMutationConfig, WSQueryCache } from "@ws-react-query";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { createPayee } from "../../../services/payees";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/usePayeeRowsQuery";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/usePayeeRowsSummaryQuery";
import { QUERY_PAYEE } from "../keys";

export const useMutationCreatePayee = (
  config?: WSMutationConfig<IPayeeResponse, WSServiceError>
) =>
  useWSMutation(
    (request: IPayeeCreateRequest) =>
      createPayee(request).then(payee => {
        WSQueryCache.setQueryData([QUERY_PAYEE, payee.payeeId, null], payee);

        return payee;
      }),
    {
      ...config,
      dependencies: [QUERY_PAYEE_ROWS_SUMMARY, QUERY_PAYEE_ROWS]
    }
  );
